import { render, staticRenderFns } from "./PrintNullTable.vue?vue&type=template&id=006701cf&scoped=true"
import script from "./PrintNullTable.vue?vue&type=script&lang=js"
export * from "./PrintNullTable.vue?vue&type=script&lang=js"
import style0 from "./PrintNullTable.vue?vue&type=style&index=0&id=006701cf&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "006701cf",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('006701cf')) {
      api.createRecord('006701cf', component.options)
    } else {
      api.reload('006701cf', component.options)
    }
    module.hot.accept("./PrintNullTable.vue?vue&type=template&id=006701cf&scoped=true", function () {
      api.rerender('006701cf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/FinanceVer2/employeeSalary/printPayment/PrintNullTable.vue"
export default component.exports